export const findCheapestShipmentRate = shipmentCharges => shipmentCharges.reduce((cheapestShipmentRate, charge) =>
// @todo. auto generated. fix this error
// @ts-ignore
charge.totalCharges < cheapestShipmentRate.totalCharges ? charge : cheapestShipmentRate, shipmentCharges[0]);